import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Link } from "react-router-dom";
import { fmtDateTime } from "../lib/format";

export default function Documents() {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    (async () => {
      // Fetch all my loads, then docs for each
      const r = await api.get("/loads", { params: { scope: "mine" } });
      const all = [];
      for (const l of r.data) {
        const d = await api.get(`/loads/${l.load_id}/documents`);
        d.data.forEach(doc => all.push({ ...doc, load_route: `${l.pickup_city} → ${l.dropoff_city}` }));
      }
      setDocs(all);
    })();
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] tracking-[0.2em] uppercase text-gold font-bold mb-2">Files</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter text-navy">Documents</h1>
      </div>
      <div className="card-base overflow-x-auto">
        <table className="table-base">
          <thead><tr><th>Filename</th><th>Type</th><th>Load</th><th>Size</th><th>Uploaded</th></tr></thead>
          <tbody>
            {docs.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-400">No documents.</td></tr>}
            {docs.map(d => (
              <tr key={d.document_id}>
                <td className="font-semibold text-slate-900">{d.filename}</td>
                <td><span className="badge accepted">{d.type}</span></td>
                <td><Link to={`/app/loads/${d.load_id}`} className="font-mono text-xs text-navy">{d.load_id}</Link><div className="text-xs text-slate-500">{d.load_route}</div></td>
                <td className="font-mono text-xs">{(d.size / 1024).toFixed(1)} KB</td>
                <td className="text-xs text-slate-500">{fmtDateTime(d.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
